// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lsc_","top":"styles_top__3NpPf","left":"styles_left__32zsC","description":"styles_description__1TVuo"};